import { render, staticRenderFns } from "./ShortPlaneDetailsPopup.vue?vue&type=template&id=60fe5807&"
import script from "./ShortPlaneDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./ShortPlaneDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports